/**
 * Use in clicking the video in homepage
 */
import { Skeleton, Stack, useMediaQuery } from "@mui/material"
import { SkeletonVideoList } from "../SkeletonVideoList/SkeletonVideoList"

export const SkeletonSubjectDialog = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    return (
        <>
            <Skeleton
                variant="rectangular"
                width={600}
                height={isMobile ? 200 : 300}
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                    borderRadius: 2,
                    mb: 3
                }}
            />
            <Skeleton
                variant="text"
                width={200}
                height={40}
            />
            <Skeleton
                variant="text"
                width={80}
                height={40}
            />
            <Skeleton
                variant="text"
                width={40}
                height={40}
            />
            <Stack spacing={2}>
                <SkeletonVideoList />
            </Stack>
        </>
    )
}